import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteDepartment } from "../../../axios/Department/DepartmentApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const RemoveDepartmentDialog = ({ onClose, onRefresh, row }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const payload = {
        departmentId: row.id,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await deleteDepartment(payload);

      if (response?.data === "") {
        onClose();
        toast.success(t("common.delete-department-successfully"));
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.delete-department")}
      subtitle={t("common.content-175")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleDelete}
    />
  );
};

export default RemoveDepartmentDialog;
